<template>
  <el-dialog
    :visible.sync="addServiceDialog"
    width="50%"
    title="设备"
    :close-on-click-modal="false"
  >
    <el-form :inline="true">
      <el-form-item>
        <el-radio-group v-model="role" @change="phone = ''">
          <el-radio label="coach">教练</el-radio>
          <el-radio label="manager">管理员</el-radio>
          <el-radio label="student">学员</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="电话">
        <el-input v-model="phone"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #name="{ row }">
        {{ getName(row) }}
      </template>
      <template #handler="{ row }">
        <div>
          <el-button type="primary" size="small" @click="changeUser(row)"
            >选择</el-button
          >
        </div>
      </template>
    </auto-table>

    <h3>添加用户</h3>

    <el-tag v-for="(u, i) in users" :key="i" closable @close="handleClose(i)">
      {{ u.userName }}
    </el-tag>
    <el-button
      type="primary"
      v-if="stuShow == false"
      size="small"
      @click="openStu"
      >生成学员</el-button
    >
    <el-button type="primary" v-else size="small" @click="stuShow = false"
      >取消</el-button
    >
    <el-form class="demo-form-inline" v-if="stuShow">
      <el-form-item label="电话">
        <el-input v-model="stu.login_name" placeholder="电话"></el-input>
      </el-form-item>
      <el-form-item label="名称">
        <el-input v-model="stu.name" placeholder="名称"></el-input>
      </el-form-item>
      <el-form-item label="性别">
        <el-radio-group v-model="stu.sex">
          <el-radio label="1">男</el-radio>
          <el-radio label="2">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="人脸">
        <avatar-uploader
          :fileSize="100"
          @getImgUrl="(v) => (stu.facePath = v)"
        ></avatar-uploader>
        人脸图片100kb以下
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">生成</el-button>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer" v-else>
      <el-button @click="addServiceDialog = false">取 消</el-button>
      <el-button :loading="loading" type="primary" @click="submitForm()"
        >添 加</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      DataList: [],
      Option: [
        { name: "姓名", value: "name", type: "custom" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      status: 1,
      role: "coach",
      addServiceDialog: false,
      device: {},
      phone: "",
      users: [],
      loading: false,
      stu: {},
      stuShow: false,
    };
  },
  methods: {
    openStu() {
      this.stuShow = true;
      this.stu = {};
    },
    getName(row) {
      return row.real_name || row.name || "-";
    },
    handleClose(i) {
      this.dynamicTags.splice(i, 1);
    },
    changeUser(row) {
      let user = {};
      if (row.coach_type) {
        user = {
          userName: row.real_name,
          userId: "coach#" + row.id,
          userType: 0,
        };
        this.users.push(user);
      } else if (row.login_name) {
        user = {
          userName: row.name,
          userId: "manager#" + row.id,
          userType: 0,
        };
        this.users.push(user);
      }else if (row.user_id) {
        user = {
          userName: row.name,
          userId: "student#" + row.user_id,
          userType: 0,
        };
        this.users.push(user);
      }
    },
    submitForm() {
      if (this.users.length == 0) {
        this.$message("请选择添加学员");
        return;
      }
      let param = {
        deviceId: this.device.device_id,
        users: this.users,
      };
      this.loading = true;
      this.$post("/device/device/addUsers", param)
        .then((res) => {
          this.loading = false;
          this.users = [];
          this.addServiceDialog = false;
          this.$message("添加成功");
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    open(row) {
      this.device = row;
      this.addServiceDialog = true;
    },
    //获取列表
    getList(v) {
      this.stuShow = false
      let page = v || 1;
      let url = "";
      let params = {
        currentPage: page,
        pageSize: 10,
      };
      if (this.role == "coach") {
        url = "/user/coach/queryListPage";
        params.phone = this.phone;
      } else if (this.role == "manager") {
        url = "/authorization/managerUser/queryListPage";
        params.login_name = this.phone;
      } else if (this.role == "student") {
        url = "/user/familyMembers/queryListPage";
        params.login_name = this.phone;
      }

      this.$get(url, params).then((res) => {
        this.DataList = res.data.data;
      });
    },
    onSubmit() {
      if (!this.stu.login_name) {
        this.$message("请输入电话");
        return;
      }
      if (!this.stu.name) {
        this.$message("请输入姓名");
        return;
      }
      let url = "/user/familyMembers/insert";
      let params = {
        ...this.stu,
         device_id: this.device.device_id,
      };
      this.$post(url, params).then((res) => {
        this.stuShow = false;
        this.stu = {};
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>